import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('updateDroneForm');

    return {
        SAVE: t('save')
    };
};

export default useTranslation;
